module.exports = __webpack_public_path__ + "media/images/responsive/flow/flow4-dress-a72ba83c79ed4f5e398cf0c1405ddb81.jpg";